// Offline: links de mapa in-app abrem o app de mapas NATIVO do device.
//
// Decisão de produto (PLANO_OFFLINE.md): o mapa in-app é online-only, mas o
// usuário pode ter baixado a área offline no próprio Google Maps. Então, quando
// OFFLINE, os links que iriam pro mapa in-app (`/mapa.html?...`) e que carregam
// um `data-maps-fallback` (URL universal do Google Maps, via deepLinks.mapsUrl)
// abrem o app nativo. ONLINE, nada muda — a navegação padrão pro mapa in-app
// segue normal.
//
// Idempotente. Inicializado por `wireMoreSheet` (shared/nav.js), uma vez por
// página. Usa captura pra interceptar antes da navegação padrão do link.

let _wired = false;

export function initOfflineMapsLinks() {
  if (_wired || typeof document === 'undefined') return;
  _wired = true;

  document.addEventListener('click', (e) => {
    // Só intervém offline. Online, deixa o link abrir o mapa in-app.
    if (typeof navigator !== 'undefined' && navigator.onLine !== false) return;

    const a = e.target?.closest?.('a[data-maps-fallback]');
    if (!a) return;
    const url = a.getAttribute('data-maps-fallback');
    if (!url) return;

    e.preventDefault();
    // `_blank` → o Capacitor roteia pro app/browser do sistema, que abre o
    // Google Maps (app se instalado; senão web).
    window.open(url, '_blank', 'noopener');
  }, true);
}
